export default (value: string, e: Event) => {
	e.preventDefault();
	e.stopPropagation();

	navigator.clipboard.writeText(value.trim());
};
